export enum TITLES {
    Error = "Error",
    Maintenance = "Maintenance"
}
